module.exports = new __parcel__URL__("mvhq_level_2.94d6acf9.png").toString();